import * as types from '../mutation-types'
import { 
    get_child_location,
    get_parent_location,
    save_change_order_locations,
    force_change_table_free,
    
} from '@/api/location'
import Vue from 'vue' 
export const getDefaultState = () => {
    return {
        selected_locations_name: 'Default',
        selected_locations_id: null,
        change_locations: false,
        sale_id: 0,
        save_change_locations: false,
        meta_table: {},
        loading_change_table: false
    }
}

export const state = {
    parent_location: [],
    child_location: [],
    selected_locations_name: 'Default',
    selected_locations_id: null,
    location_status: false,
    loading: false,
    change_locations: false,
    sale_id: 0,
    save_change_locations: false,
    meta_table: {},
    loading_change_table: false
}
export const getters = {
    loading: state => state.loading,
    parent_location: state => state.parent_location,
    child_location: state => state.child_location,
    selected_locations_name: state => state.selected_locations_name,
    selected_locations_id: state => state.selected_locations_id,
    location_status: state => state.location_status,
    change_locations: state => state.change_locations,
    sale_id: state => state.sale_id,
    meta_table: state => state.meta_table,
    save_change_locations: state => state.save_change_locations,
    loading_change_table: state=>state.loading_change_table
}
export const mutations = {
    [types.SUBMIT_CHANGE_LOCATIONS](state, payload) {
        state.save_change_locations = payload;
    },
    [types.SAVE_ORDER_CHANGE_LOCATION_SUCCESS](state, payload) {
        Vue.notify({
            group: 'notification',
            title: 'Completed',
            type: 'success',
            speed: 500,
            text: 'Your change order locations Successful',
        });
        state.save_change_locations = true;
    },
    [types.SAVE_ORDER_CHANGE_LOCATION_FAILD](state, payload) {
        state.save_change_locations = false
    },
    [types.FETCH_LOCATION](state, payload) {
        state.loading = true;
        state.parent_location = payload;
    },
    [types.FETCH_SALE_ID](state, payload) {
        state.sale_id = payload
    },
    [types.MUTATION_CHANGE_LOCATIONS_ACTION](state, payload) {
        state.change_locations = payload
    },
    [types.FETCH_LOCATION_SUCCESS](state, payload) {
        state.loading = false; 
        state.parent_location = payload.data;
        state.meta_table = {
            from: payload.from,
            last_page: payload.last_page,
            per_page: payload.per_page,
            to: payload.to,
            total: payload.total,
        }
    },
    [types.FETCH_LOCATION_FAILED](state, payload) {
        state.loading = false;
        state.parent_location = [];
    },
    [types.FETCH_CHILD_LOCATION](state, payload) {
        state.loading = true;
        state.child_location = payload;
    },
    [types.FETCH_CHILD_LOCATION_SUCCESS](state, payload) {
        state.loading = false;
        state.child_location = payload;
    },
    [types.FETCH_CHILD_LOCATION_FAILED](state, payload) {
        state.loading = false;
        state.child_location = [];
    },
    [types.FETCH_SELECTED_LOCATION_NAME](state, payload) {
        state.selected_locations_name = payload;
    },
    [types.FETCH_SELECTED_LOCATION_ID](state, payload) {
        state.selected_locations_id = payload;
    },
    [types.FETCH_LOCATION_STATUS_SUCCESS](state, payload) {
        if (state.location_status) {
            Object.assign(state, getDefaultState())
        }
    },
    [types.RESET_LOCATION_STATE](state, payload) {
        state.location_status = payload;
        Object.assign(state, getDefaultState())
    },

    forceFreeTable(state, payload){
        state.loading_change_table = true;
    },

    forceFreeTableFail(state, payload){
        state.loading_change_table = false;
    },
    
    forceFreeTableDone(state, payload){
        state.loading_change_table = false;
    },




}
export const actions = {

   

    async forceFreeTable({ commit }, payload) {
        commit('forceFreeTable');
        try {
            const data = await force_change_table_free(payload);
            commit("forceFreeTableDone", data);
        } catch (error) {
            let error_ = error.response;
            commit('forceFreeTableFail', error_);
        }
    },

    async get_locations({ commit }, payload) {
        commit(types.FETCH_LOCATION);
        try {
            const data = await get_parent_location(payload);

            commit(types.FETCH_LOCATION_SUCCESS, data);
        } catch (error) {
            let error_ = error.response;
            commit(types.FETCH_LOCATION_FAILED, error_);
        }
    },
    async fetch_child_location({ commit, state }, payload) {
        commit(types.FETCH_CHILD_LOCATION);
        try {
            state.parent_location.forEach((el, index) => {
                if (el.parent_id === payload)
                    commit(types.FETCH_CHILD_LOCATION_SUCCESS, el)
            })
        } catch (error) {
            let error_ = error.response;
            commit(types.FETCH_CHILD_LOCATION_FAILED, error_);
        }
    },
    async fetch_selected_locations_name({ commit }, payload) {
        commit(types.FETCH_SELECTED_LOCATION_NAME);
        try {
            commit(types.FETCH_SELECTED_LOCATION_NAME, payload.location_name);
            commit(types.FETCH_SELECTED_LOCATION_ID, payload.location_id)
        } catch (error) {
            let error_ = error.message();
            commit(types.FETCH_CHILD_LOCATION_FAILED, error_);
        }
    },
    async getLocationStatus({ commit }, payload) {
        try {
            commit(types.FETCH_LOCATION_STATUS_SUCCESS, payload)
        } catch (error) {
            const err = error.message();
            commit(types.FETCH_LOCATION_STATUS_ERROR, err);
        }
    },
    async resetLocationState({ commit }, payload) {
        commit(types.RESET_LOCATION_STATE, payload)
    },
    async saveOrderChangeLocation({ commit }, payload) {
        commit(types.SUBMIT_CHANGE_LOCATIONS);
        try {
            const respone = await save_change_order_locations(payload);
            commit(types.SAVE_ORDER_CHANGE_LOCATION_SUCCESS, respone);
        } catch (error) {
            const err_ = error.response;
            commit(types.SAVE_ORDER_CHANGE_LOCATION_FAILD, err_)
        }
    },
    updateChangeLocationsAction({ commit }, payload) {
        commit(types.MUTATION_CHANGE_LOCATIONS_ACTION, payload);
    },
    getSaleID({ commit }, payload) {
        commit(types.FETCH_SALE_ID, payload);
    }
}
